module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_9.cc78116a.jpg";